<template>
    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form">
        <el-form-item prop="tel">
            <el-input v-model.trim="loginForm.tel" placeholder="请输入手机号" maxlength="11" ref="tel" clearable></el-input>
        </el-form-item>
        <el-form-item prop="code">
            <el-input class="padding-right" v-model.trim="loginForm.code" placeholder="请输入验证码"
                maxlength="6" clearable></el-input>
            <el-button v-show="codeSta"
                :class="{'get-code-btn': true, 'disabled': !loginForm.tel || !/^1[3456789]\d{9}$/.test(loginForm.tel)}"
                @click="getCode()">获取验证码</el-button>
            <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s</el-button>
        </el-form-item>
        <div class="login-btn">
            <el-button type="primary" @click="submitForm('loginForm')"
                :disabled="!loginForm.tel || !loginForm.code">立即绑定
            </el-button>
        </div>
    </el-form>
</template>

<script>
import loginApi from '@/resources/loginModule/login'

export default {
    data() {
        // 验证手机号
        let checkTel = (rule, value, callback) => {
            let reg = /^1[3456789]\d{9}$/;
            if (!value) {
                return callback(new Error("请输入手机号"));
            } else if (!reg.test(value)) {
                return callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        return {
            activeTab: 'login',
            codeSta: true, // 获取验证码按钮状态
            count: '',
            timer: null,
            // 表单数据
            loginForm: {
                tel: '',
                code: ''
            },
            //校验
            rules: {
                tel: [{ required: true, validator: checkTel, trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
        };
    },
    methods: {
        // 获取验证码
        getCode() {
            if (!/^1[3456789]\d{9}$/.test(this.loginForm.tel)) {
                return false;
            }
            let para = {
                mobile: this.loginForm.tel,
                operationFlag: 4, //1.注册 2.忘记密码 3.登录 4.绑定手机号
            };
            loginApi.sendMobileCode(para).then((res) => {
                if (res.returnCode === 200) {
                    this.codeCountdown();
                }
            });
        },
        // 验证码倒计时
        codeCountdown() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.codeSta = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.codeSta = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        sendMessageToParent(data) {
            let appId = sessionStorage.appId;
            let originPort = sessionStorage.originPort;
            let originUrl2 = 'http://localhost:' + originPort;
            let originUrl = this.originUrl || sessionStorage.originUrl;
            // debugger
            switch (appId) {
                case 'DnNXo': {
                    try {
                        parent.postMessage(data, originUrl);
                    } catch (e) {
                        console.log(e);
                    }
                    try {
                        parent.postMessage(data, originUrl2);
                    } catch (e) {
                        console.log(e);
                    }
                    break;
                }
                default: {
                    if (originUrl) {
                        parent.postMessage(data, originUrl);
                    } else {
                        parent.postMessage(data, originUrl2);
                    }
                    break;
                }
            }
        },
        // 手机号绑定
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let para = {
                        mobile: this.loginForm.tel,
                        captcha: this.loginForm.code,
                        unionId: this.$route.query.unionId
                    };
                    loginApi.wxBind(para).then((res) => {
                        if (res.returnCode === 200) {
                            this.$message.success('绑定成功');
                            this.sendMessageToParent(res.data);
                        }
                    })
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
@import "~@/assets/css/login/login.css";
</style>